import GetUserListDummyData from "../../../dummy/GetUserListDummyData.json";
import GetUserInfoDummyData from "../../../dummy/GetUserInfoDummyData.json";
import UpdateUserInfoDummyData from "../../../dummy/UpdateUserInfoDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import UserListDto from "../dto/user/UserListDto";
import UserInfoDto from "../dto/user/UserInfoDto";

class FakeUserApi {
    getUserList = async ({
        page = 1,
        pageSize = 20,
    }: {
        page?: number;
        pageSize?: number;
        enabled?: string;
        search?: string;
    } = {}): Promise<SuccessResponse<UserListDto>> => {
        const curPage = Number(page) || 1;
        const size = Math.min(Number(pageSize) || 20, 50);

        const allUsers = GetUserListDummyData.result.users;

        const totalCount = allUsers.length;
        const totalPage = Math.max(1, Math.ceil(totalCount / size));
        const start = (curPage - 1) * size;
        const users = allUsers.slice(start, start + size);

        return {
            ...GetUserListDummyData,
            result: {
                page: { curPage, totalPage, totalCount, pageSize: size },
                users,
            },
        };
    };

    getUserInfo = async (): Promise<SuccessResponse<UserInfoDto>> => {
        return GetUserInfoDummyData;
    };

    updateTargetUserInfo = async (): Promise<SuccessResponse<Record<string, never>>> => {
        return UpdateUserInfoDummyData;
    };
}

export default FakeUserApi;
